import { store } from '../redux/storeConfig/store';
import { checkEmailToken } from '../redux/actions/auth/emailTokenActions';

const setEmailToken = (token) => {
  localStorage.setItem('EmailToken', token);
  checkEmailToken({ emailToken })(store.dispatch);
};
export const removeEmailToken = (token) => {
  return localStorage.removeItem('EmailToken');
};

export const getEmailToken = () => {
  return localStorage.getItem('EmailToken');
};

const url = new URL(window.location.href);
const emailToken = url.searchParams.get('token');

window.initialPath = url.pathname;

if (emailToken) {
  setEmailToken(emailToken);
}
